"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkColumnStyle = checkColumnStyle;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkColumnStyle(columnData) {
  var column = _objectSpread({}, columnData);
  if (column.cellStyle) {
    var oldOnCell = column.onCell;
    var result = {};
    column.onCell = function (record, rowIndex) {
      if (oldOnCell) result = oldOnCell(record, rowIndex);
      var classNameString = [typeof column.cellStyle === 'function' ? column.cellStyle(record, rowIndex) : column.cellStyle, result['className']].join(' ');
      return _objectSpread(_objectSpread({}, result), {}, {
        className: classNameString
      });
    };
  }
  return column;
}
var _default = exports.default = {
  checkColumnStyle: checkColumnStyle
};